import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import Nora from '@primeng/themes/nora';

/**
 * Preset personalizado para el tema "Spa Center".
 * Define una paleta de colores suaves (rosas y melocotones) y bordes redondeados
 * para evocar una sensación de relajación y bienestar.
 * 
 * Basado en el preset 'Nora' de PrimeNG.
 */
export const SpaPreset = definePreset(Nora, {
    semantic: {
        primary: {
          50: '{green.50}',
          100: '{green.100}',
          200: '{green.200}',
          300: '{green.300}',
          400: '{green.400}',
          500: '{green.500}',
          600: '{green.600}',
          700: '{green.700}',
          800: '{green.800}',
          900: '{green.900}',
          950: '{green.950}'
        },
        colorScheme: {
            light: {
                surface: {
                  50: '{ocean.50}',
                  100: '{ocean.100}',
                  200: '{ocean.200}',
                  300: '{ocean.300}',
                  400: '{ocean.400}',
                  500: '{ocean.500}',
                  600: '{ocean.600}',
                  700: '{ocean.700}',
                  800: '{ocean.800}',
                  900: '{ocean.900}',
                  950: '{ocean.950}'
                }
            }
        }
    },
    components: {
        button: {
            colorScheme: {
                light: {
                    root: {
                        borderRadius: '0'
                    }
                }
            }
        },
        inputGroup: {
            colorScheme: {
                light: {
                    root: {
                        borderRadius: '0'
                    }
                }
            }
        },
        inputtext: {
            colorScheme: {
                light: {
                    root: {
                        borderRadius: '0'
                    }
                }
            }
        },
        card: {
            colorScheme: {
                light: {
                    root: {
                        borderRadius: '0',
                        shadow: '0 10px 30px rgba(0,0,0,0.05)'
                    }
                }
            }
        }
    }
});
